export default {
  'globalHeader.avatar.changePwd': '修改密码',
  'globalHeader.changePwd.title': '修改密码',
  'globalHeader.changePwd.oldPassword': '旧密码',
  'globalHeader.changePwd.oldPassword.required': '请输入旧密码',
  'globalHeader.changePwd.newPassword': '新密码',
  'globalHeader.changePwd.newPassword.required': '请输入新密码',
  'globalHeader.changePwd.newPassword.sameAsOld': '新密码不能与旧密码相同',
  'globalHeader.changePwd.confirmPassword': '确认新密码',
  'globalHeader.changePwd.confirmPassword.required': '请再次输入新密码',
  'globalHeader.changePwd.confirmPassword.mismatch': '两次输入的新密码不一致',
  'globalHeader.changePwd.success': '修改成功,请重新登录',
};
